import React, { useState } from 'react';
import AccordionStateless from './AccordionStateless/AccordionStateless';
import { CreateProps } from '../../types/utils/CreateProps';

type AccordionProps = CreateProps<
  {
    /** Visible heading in the Accordion */
    heading: string;
    /** Controls if the Accordion is initially expanded or not */
    initiallyExpanded?: boolean;
    /** Use regular or heading font */
    useHeadlineFontOnHeading?: boolean;
  },
  typeof AccordionStateless,
  'onClick' | 'open'
>;

const Accordion: React.FunctionComponent<AccordionProps> = ({
  children,
  initiallyExpanded,
  ...props
}) => {
  const [open, setOpen] = useState(initiallyExpanded || false);

  const toggleExpanded = () => {
    setOpen(!open);
  };

  return (
    <AccordionStateless onClick={toggleExpanded} open={open} {...props}>
      {children}
    </AccordionStateless>
  );
};

export default Accordion;
